import useAgentData from '~/client/hooks/useAgentData';
import InfoPopover from './InfoPopover';
import InfoTooltip from './InfoTooltip';

const infoTranslationId = 'profile.choose_ingame_currency';

const InfoButton: FC = () => {
  const { isMobile } = useAgentData();
  if (isMobile) {
    // TODO: remove popover when Tooltip works for mobile
    return <InfoPopover popoverContent={infoTranslationId} />;
  }
  return <InfoTooltip tooltipContent={infoTranslationId} />;
};

export default InfoButton;
